import React, { useContext, useEffect } from 'react';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { OnOffIcon } from '@assets/icons/onOffIcon';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import IconButton from '@components/IconButton';
import { useDispatch} from 'react-redux';
import { ReactComponent as LSIcon } from '@assets/svgs/lead-science-icon-white.svg'

const LogOut:React.FC<IProps> = (props) => {
const authContext = useContext(AuthContext);
const [LeadScienceUser, setLeadScienceUser] = React.useState<boolean>();

  const handleOpenDealerOn= async () => {
    await authContext.logOut()
    window.open('https://cms.dealeron.com', '_self');
  }

useEffect(() => {
  setLeadScienceUser(authContext.LeadScienceUser);  
}, []);

  return (
      <S.Root>
        <S.VerticalBar>
          <S.IconContainer onClick={() => handleOpenDealerOn()} >
          <IconButton
              hoverBackgroundColor={C.LIGHT_GRAY}
            >
          { 
          
          !LeadScienceUser
          ?    
            <OnOffIcon />
          :
            <LSIcon style={{width: '25px', height: '28px' }} />
          }    
            </IconButton>
          </S.IconContainer>
        </S.VerticalBar>
      </S.Root>
  );
}

export default LogOut;